module.exports = __webpack_public_path__ + "facelifting_2_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/facelifting_2_before_tn.jpg
// module id = 1520
// module chunks = 0